import React, {Component} from "react";
import MenuGroup from "./MenuGroup";
import {graphql} from "react-apollo";
import gql from "graphql-tag";

function getEnvTitle() {
  switch (process.env.REACT_APP_ENV) {
    case "production": 
      return "Production";
    case "staging":
      return "Staging";
    default:
      return "Development"
  }
}

function noOp() {
  return null;
}

class VersionInfo extends Component {

  render() {
    let {loading, error, systemVersion} = this.props.data;
    let serverEl = null;
    if (!loading && !error && systemVersion) {
      serverEl = <span key="systemVersion" className="item" onClick={noOp}>Server: <strong>{systemVersion.version}</strong></span>
    }
    return (
      <MenuGroup label={getEnvTitle()} version={true} production={process.env.REACT_APP_ENV === "production"} right={this.props.right}>
        <span className="item" onClick={noOp}>Client: <strong>{process.env.REACT_APP_VERSION}</strong></span>
        {serverEl}
      </MenuGroup>
    )
  }

}

VersionInfo.defaultProps = {
  right: false
}

const SYSTEM_VERSION = gql`
  query systemVersion {
    systemVersion {
      version
    }
  }
`

const withQuery = graphql(SYSTEM_VERSION, {
  fetchPolicy: "network-only"
})

export default withQuery(VersionInfo);